export default __webpack_public_path__ + "static/media/nft-super.c4ac6435.jpg";